import React, { useImperativeHandle, useRef } from "react";
import { RadioProps } from "./Radio.types";
import styles from "./Radio.module.scss";

const Radio = React.forwardRef<
  HTMLInputElement,
  RadioProps
>((props, ref) => {

  const inputRef = useRef<HTMLInputElement>(null);
  useImperativeHandle(ref, () => inputRef.current);
  return (
    <button className={styles.Radio} data-zoom={props.zoom} disabled={props.disabled} data-testid="Radio"
            onClick={() => inputRef.current.click()}>
      <div className={styles.circle} />
      <input ref={inputRef} type="radio" hidden {...props}></input>
    </button>
  );
});

Radio.displayName = "Radio";

export default Radio;
